import {AsYouType, CountryCode} from 'libphonenumber-js';

/**
 * Parse partial or full national phone number and validate for the given country code.
 * @param countryCode 2-letter ISO country code
 * @param partialNumber partial value
 */
export const parseNationalNumber = (
  countryCode: string,
  partialNumber: string,
): {
  /**
   * Is the number provided valid
   */
  isValid: boolean;
  /**
   * Number formatted as national number, i.e. no country code prefix. On error, given partialNumber is returned.
   */
  nationalNumberFormatted: string;
  /**
   * Number formatted as international number, i.e. with country code prefix
   */
  internationalNumberFormatted?: string;
  /**
   * International number with no formatting. `undefined` if no valid
   */
  number?: string;
} => {
  try {
    const asYouType = new AsYouType(countryCode as CountryCode);
    const nationalNumberFormatted = asYouType.input(partialNumber);
    const numberInfo = asYouType.getNumber();
    const intl = numberInfo?.formatInternational();
    const isValid = numberInfo?.isValid() ?? false;
    asYouType.reset();
    const internationalNumberFormatted = intl
      ? asYouType.input(intl)
      : undefined;
    const number = isValid
      ? asYouType.getNumber()?.number.toString()
      : undefined;
    const result = {
      number,
      nationalNumberFormatted,
      internationalNumberFormatted,
      isValid,
    };
    return result;
  } catch (error) {
    return {
      isValid: false,
      nationalNumberFormatted: partialNumber,
    };
  }
};
